module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-RegularItalic-WebXL-572a17eb5bcaf47132af1038fc72e9b8.woff2";